export function ErrorBanner({
  heading,
  msg,
}: {
  heading?: string;
  msg: Error | string | null | undefined;
}) {
  if (!msg) return null;

  return (
    <div className="mb-4">
      <s-banner dismissible tone="critical" {...(heading ? { heading } : {})}>
        {msg instanceof Error ? msg.message : msg}
      </s-banner>
    </div>
  );
}
